import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

export const MidPageCTA = () => {
  const navigate = useNavigate();
  
  return (
    <section className="py-16 md:py-20 bg-gradient-to-r from-purple-900 to-red-900 text-white">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center">
          <motion.h2 
            className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 md:mb-6"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0, transition: { duration: 0.6 } }}
            viewport={{ once: true }}
          >
            ¡La risa está a un clic de distancia!
          </motion.h2>
          <motion.p 
            className="text-lg md:text-xl mb-6 md:mb-8"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0, transition: { duration: 0.6, delay: 0.2 } }}
            viewport={{ once: true }}
          >
            Accede ahora a los mejores shows de comedia en una sola plataforma
          </motion.p>
          <motion.button
            className="bg-red-600 hover:bg-red-700 text-white py-3 md:py-4 px-8 md:px-10 rounded-lg text-lg md:text-xl font-medium shadow-lg hover:shadow-red-500/50 transform transition-all duration-300 hover:scale-105 w-full sm:w-auto sm:min-w-[200px]"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1, transition: { duration: 0.6, delay: 0.4 } }}
            viewport={{ once: true }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.98 }}
            onClick={() => navigate("/login")}
          >
            Comenzar ahora
          </motion.button>
        </div>
      </div>
    </section>
  );
};